/* eslint-disable @typescript-eslint/no-explicit-any */

// Spreadsheet content arrives in two shapes depending on where it was produced:
// the in-exam editor saves a sparse list of populated cells, while anything
// imported from a file keeps its sheets as row matrices. Normalising here lets
// both the preview table and the .xlsx export work off one representation.
export type SpreadsheetCell = {
  row: number;
  col: number;
  value: string;
};

export type SheetMatrix = Record<string, any[][]>;

export const toRows = (
  source: SpreadsheetCell[] | SheetMatrix | null | undefined
): string[][] => {
  if (!source) return [];

  if (Array.isArray(source)) {
    if (source.length === 0) return [];
    const maxRow = Math.max(...source.map((c) => c.row));
    const maxCol = Math.max(...source.map((c) => c.col));
    const grid: Record<string, string> = {};
    source.forEach((c) => {
      grid[`${c.row}-${c.col}`] = c.value;
    });
    return Array.from({ length: maxRow + 1 }, (_, r) =>
      Array.from({ length: maxCol + 1 }, (_, c) => grid[`${r}-${c}`] ?? "")
    );
  }

  // Only the first sheet is used; the exam editor produces a single one.
  const firstSheet = Object.values(source)[0];
  if (!Array.isArray(firstSheet)) return [];
  return firstSheet.map((row) =>
    (Array.isArray(row) ? row : [row]).map((cell) =>
      cell === null || cell === undefined ? "" : String(cell)
    )
  );
};
